import _extends from "@babel/runtime/helpers/extends";
import { Box, SvgIcon, MenuItem, Typography, Divider, useMediaQuery } from "@mui/material";
import { RoundClearIcon } from "../../../assets/customIcons";
import { FormSearchSelect } from "../../../builderPackage/components/dynamicFormBuilder/components/formSearchSelect";
import { MuiStack } from "../../atoms/stackComponent";
var ModuleSearch = function () {
    var upXS = useMediaQuery(function (theme) { return theme.breakpoints.up("xs"); });
    var downSM = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var IS_MOBILE = upXS && downSM;
    return /*#__PURE__*/ React.createElement(Box, {
        width: "320px",
        justifyContent: 'flex-start'
    }, /*#__PURE__*/ React.createElement(FormSearchSelect
    // autoFocus={props.isSearchActive}
    , {
        sx: {
            my: 1,
            width: 500,
            backgroundColor: '#fff',
            borderRadius: '8px',
            '& .MuiInputBase-root': {
                height: '36px'
            },
            "& .MuiInputBase-input": {
                p: 3,
                color: 'black',
                padding: 1,
                height: '29px'
            },
            "& .MuiInputBase-sizeSmall": {
                padding: "8px"
            }
        }
        // InputProps={{
        //     startAdornment: (
        //         <InputAdornment position="start">
        //             <img src={SearchIcon} alt="" style={{ width: '18px', height: '18px', marginRight: '8px' }} />
        //         </InputAdornment>
        //     ),
        // }}
        ,
        id: "search",
        name: "search",
        placeholder: "Search by VIN, Reg No, Customer name",
        noOptionsText: "No records found",
        fullWidth: true,
        value: "",
        clearIcon: /*#__PURE__*/ React.createElement(SvgIcon, {
            component: RoundClearIcon,
            sx: {
                color: '#fff',
                width: "17.6px",
                height: '18px',
                variant: 'h2'
            }
        })
        // onChange={(e: any, value: any) => { handleNavigation(value) }}
        ,
        getOptionLabel: function (option) { return option === null || option === void 0 ? void 0 : option.RegistrationNo; },
        filterOptions: function (options) { return options; },
        valueExpr: "id"
        // getListData={globalSearchAPICall}
        ,
        forcePopupIcon: false,
        ListboxProps: {
            sx: {
                width: 'auto'
            }
        },
        slotProps: {
            paper: {
                sx: {
                    width: '100%',
                    borderRadius: '8px !important'
                }
            },
            popper: {
                anchorEl: document.getElementById('search-container'),
                sx: {
                    width: '100% !important',
                    px: 2,
                    borderRadius: '8px !important',
                    paddingTop: '8px !important',
                    display: 'none'
                }
            }
        },
        renderOption: function (props, option, state) {
            var _option$RegistrationN;
            // const isLastOption = state?.index === response?.length - 1;
            return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(MenuItem, _extends({}, props, {
                sx: {
                    m: 0,
                    p: 0
                }
            }), /*#__PURE__*/ React.createElement(MuiStack, {
                justifyContent: 'space-between',
                width: '100%'
            }, /*#__PURE__*/ React.createElement(MuiStack, {
                direction: "column",
                alignItems: 'start',
                width: '135px'
            }, /*#__PURE__*/ React.createElement(Typography, {
                fontSize: "14px",
                sx: {
                    textWrap: 'pretty',
                    wordBreak: 'break-all',
                    fontWeight: "500"
                }
            }, (_option$RegistrationN = option === null || option === void 0 ? void 0 : option.RegistrationNo) !== null && _option$RegistrationN !== void 0 ? _option$RegistrationN : '-'), /*#__PURE__*/ React.createElement(Typography, {
                fontSize: "12px",
                alignItems: 'start',
                color: "textSecondary",
                sx: {
                    textWrap: 'pretty',
                    wordBreak: 'break-all'
                }
            })), /*#__PURE__*/ React.createElement(MuiStack, {
                direction: "column",
                alignItems: 'end',
                width: "50%"
            }, /*#__PURE__*/ React.createElement(Typography, {
                fontSize: "14px",
                fontWeight: "400",
                sx: {
                    textWrap: 'pretty',
                    textAlign: 'end'
                }
            }, !(option !== null && option !== void 0 && option.GivenName) && !(option !== null && option !== void 0 && option.FamilyName) ? '-' : "".concat(option === null || option === void 0 ? void 0 : option.GivenName, " ").concat(option === null || option === void 0 ? void 0 : option.FamilyName)), /*#__PURE__*/ React.createElement(Typography, {
                fontSize: "12px",
                color: "textSecondary",
                sx: {
                    textWrap: 'pretty',
                    wordBreak: 'break-all',
                    textAlign: 'end'
                }
            })))), /*#__PURE__*/ React.createElement(MuiStack, {
                display: "flex",
                justifyContent: "center"
            }, /*#__PURE__*/ React.createElement(Divider, {
                style: {
                    width: '95%'
                }
            })));
        }
    }));
};
export default ModuleSearch;
